import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";
import AudioPlayer from "../../Archive/audioWrap/AudioPreview";
import MediaComponent from "./mediaComponent/MediaComponent";
/**
 * Component for previewing files offline.
 *
 * @param {Object} props - Component props.
 * @param {Object} props.schema - Form schema for the file.
 * @param {string} props.label - Label for the file.
 * @param {string} props.datapointID - ID of the datapoint associated with the file.
 * @param {Object[]} props.files - Files data.
 * @param {string} props.status - Status of the file preview (online or offline).
 * @returns {JSX.Element} - File preview component.
 */
const FileFactoryOfflinePreview = (props) => {
  const { schema, label, datapointID, files, status } = props;

  const [extraInfo, setExtraInfo] = useState("");
  const [currentFiles, setCurrentFiles] = useState([]);

  /**
   * Handles redo click action. Here is does nothing.
   */
  async function handleRedoClick() {
    // Do nothing
  }

  useEffect(() => {
    if (datapointID && schema) {
      setExtraInfo(schema?.extraInfo);
    }
    if (files) {
      if (status === "offline") {
        const key = schema?.path;
        const filteredFiles = files
          .filter((file) => file.label === key)
          .map((file) => {
            const shouldAddDuration = schema?.media === "audio" || schema?.media === "video";
            return {
              file: file.data,
              ...(shouldAddDuration && { duration: file.metadata.duration }),
            };
          });

        setCurrentFiles(filteredFiles);
      } else {
        setCurrentFiles(files[schema?.path]);
      }
    }
  }, [schema, datapointID]);

  return (
    <Paper
      elevation={3}
      style={{ padding: "16px", borderRadius: "8px", marginTop: "16px" }}
    >
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {label}
        {schema?.file_required && <span>*</span>}
      </Typography>
      {extraInfo && (
        <List dense>
          {extraInfo.map((info, index) => (
            <ListItem key={index}>
              <ListItemText
                primaryTypographyProps={{
                  variant: "subtitle2",
                  color: "textSecondary",
                }}
              >
                {info}
              </ListItemText>
            </ListItem>
          ))}
        </List>
      )}
      <Box mt={2}>
        {currentFiles?.length !== 0 ? (
          <List style={{ padding: 0 }}>
            {currentFiles?.map((file, index) => (
              <ListItem key={index} style={{ marginBottom: "16px" }}>
              <MediaComponent
                file={file}
                schema={schema}
                status={status}
                handleRedoClick={handleRedoClick}
              />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography>No files here</Typography>
        )}
      </Box>
    </Paper>
  );
};

export default FileFactoryOfflinePreview;
